
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  [fullScreen]="true"
  [zIndex]="99999"
  size="medium"
  type="ball-spin-clockwise"
>
  <p
    style="
    margin-top: 2rem;
      color: white;
      font-family:
        Volvo Broad Pro Digital,
        sans-serif !important;
      letter-spacing: 1px;
      font-size: 18px;
    "
  >
    {{ 'Carregando...' | translate }}
  </p>
</ngx-spinner>


<router-outlet></router-outlet>
<app-footer></app-footer>
